<template></template>
<script>
import { mapGetters, mapState } from "vuex";
import { useWindowResize } from "@sichern/ui-elements";
import Users from "../../../../apiClient/Users"

export default {
  name: 'ztLogout',
  data () {
    return {
      windowResize: useWindowResize(this),
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters({
      getCompanyLoginUrl: 'getCompanyLoginUrl'
    }),
    getCompanyLogin() {
      return this.getCompanyLoginUrl
    },
    isMobile() {
      return this.windowResize.width < 1024
    }
  },
  async created() {
    const companyUrl = this.getCompanyLogin
    this.usersClient = new Users()
    await this.usersClient.logOut()
    sessionStorage.removeItem('login-tr-fired')
    this.$store.dispatch('setJwt', { jwt: '' })
    this.$store.dispatch('clearState')
    if (this.isMobile && companyUrl !== '') {
      window.location.href = `https://${companyUrl}`
    } else {
      this.$router.push({ name: 'login' })
    }
  }
}
</script>
